import { useEffect, useMemo  } from 'react';
import { usePostHog } from 'posthog-js/react';
import { useCurrentUser } from './current-user';

export const useTracking = ({ title } = {}) => {
  const posthog = usePostHog();
  const { user } = useCurrentUser();

  useEffect(() => {
    if (user) {
      posthog?.identify(user.id, {
        email: user.email,
      });
    }
  }, [posthog, user])

  const obj = useMemo(
    () => ({
      sendEvent: (action, props) => {
        if (process.env.NODE_ENV !== 'development') {
          const res = posthog?.capture(action, props);
          console.info('[LetsForm] Event: ' + action, props, res?.uuid);
        } else {
          console.info('[LetsForm] Event: ' + action, props);
        }
      },
      posthog,
      getCookieConsent: () => {
        if (!localStorage.getItem('cookie_consent')) {
          return 'undecided';
        }
        return localStorage.getItem('cookie_consent');
      },
      setCookieConsent: consent => {
        localStorage.setItem('cookie_consent', consent ? 'yes' : 'no');
        posthog.set_config({ persistence: consent ? 'localStorage+cookie' : 'memory' });
        // store when the consent was given
        if (consent) {
          posthog.capture(
            '$set',
            {
                $set: { consentGivenAt: new Date().toISOString() }
            }
          );
        }
      }
    }),
    [posthog]
  );

  return obj;
};
